import React from 'react';
import { Box, Button, ButtonAppearance, Modal, ModalBody, ModalFooter, Text, useModalState } from '@bechtel/gds';
import { ModalHeaderStyled } from '@bechtel/client-common';
import { t, Trans } from '@lingui/macro';

export const BulkActionError = ({ action, onClose: onParentClose }) => {
  const { visible, close } = useModalState(true);

  return (
    <Modal visible={visible} data-testid="bulk-action-error">
      <ModalHeaderStyled title={t`Milestone action Error`}></ModalHeaderStyled>
      <ModalBody>
        <Box px={{ sm: '500' }} py={{ sm: '700' }}>
          <Text size="600">
            <Trans> One or more milestones cannot be {action} due to a system error. Please try again later.</Trans>
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button
              appearance={ButtonAppearance.SECONDARY}
              onClick={() => {
                onParentClose();
                close();
              }}
            >
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
